import * as React from 'react';
import update from 'immutability-helper';
import { Accordion, AccordionTitleProps, Grid } from 'semantic-ui-react';
import { DropdownItem } from 'types/dropdown-item';
import { getI18n } from 'services/i18n-service';
import { hasPermissionToAccessPage } from 'helpers/permission-helper';
import { NmvsProvider } from 'types/nmvs-provider';
import { NmvsProviderCredentialsComponent } from 'components/settings/nmvs-provider-credentials';
import { Permission } from 'types/permission';
import { SettingsMenuItem } from 'types/settings-menu-item';
import { SettingsSection } from 'components/settings/settings-section';
import { Tenant } from 'types/tenants/tenant';
import { TenantPreferencesForm } from 'components/settings/tenant-preferences-form';
import { translations } from 'types/translations';

import './styles.css';
import { Scrollable } from 'components/scrollable/component';

export interface Props {
  isOnline: boolean;
  isProcessing: boolean;
  languageOptions: DropdownItem[];
  permissions: string;
  tenant: Tenant;
  getTenant?: () => void;
  updateNmvsProviderCredentials?: () => void;
  clearErrorMessage?: () => void;
}

// tslint:disable-next-line:no-any
export class SettingsPage extends React.Component<any, any> {

  constructor(props: Props) {
    super(props);

    this.setMenuItem = this.setMenuItem.bind(this);
    this.updateTenantPreferences = this.updateTenantPreferences.bind(this);
    this.setTenant = this.setTenant.bind(this);
    this.getActiveMenuItem = this.getActiveMenuItem.bind(this);

    this.state = {
      activeMenuItem: SettingsMenuItem.Unknown,
      tenant: props.tenant,
      languageOptions: props.languageOptions,
      isProcessing: props.isProcessing
    };
  }

  componentWillMount() {
    this.props.getTenant();
  }

  componentWillReceiveProps(props: Props) {
    this.setState(update(this.state, {
      activeMenuItem: { $set: this.getActiveMenuItem() },
      tenant: {
        $set: props.isProcessing === true
          ? this.state.tenant
          : props.tenant
      }
    }));
  }

  public render() {
    const i18n = getI18n();

    return (
      <Scrollable>
        <Grid columns={1} padded="horizontally" className="form-page settings-page">
          <Grid.Row>
            <Grid.Column width={16} className="padding-right">
              <Grid className="panel">
                <Grid.Row>
                  <Grid.Column computer={8} mobile={16}>
                    <Accordion className="settings-menu">
                      {this.hasAccessToPreferencesSection() &&
                        <SettingsSection
                          name="preferences"
                          activeIndex={this.state.activeMenuItem}
                          index={SettingsMenuItem.Preferences}
                          title={i18n.t(translations.Preferences)}
                          setMenuItem={this.setMenuItem}
                        >
                          <TenantPreferencesForm
                            tenant={this.state.tenant}
                            languageOptions={this.props.languageOptions}
                            setTenant={this.setTenant}
                            isProcessing={this.props.isProcessing}
                            updateTenantPreferences={this.updateTenantPreferences}
                            permissions={this.props.permissions}
                            isOnline={this.props.isOnline} />
                        </SettingsSection>
                      }
                      {this.hasAccessToCredentialsSection() &&
                        <SettingsSection
                          name="provider-creds"
                          activeIndex={this.state.activeMenuItem} index={SettingsMenuItem.NmvsProviderCredentials}
                          title={NmvsProvider[this.state.tenant.nmvsProvider] + ' ' + i18n.t(translations.Credentials)}
                          setMenuItem={this.setMenuItem}
                        >
                          <NmvsProviderCredentialsComponent
                            isProcessing={this.props.isProcessing}
                            tenantId={this.props.tenant.id}
                            nmvsProvider={this.props.tenant.nmvsProvider}
                            updateNmvsProviderCredentials={this.props.updateNmvsProviderCredentials}
                            permissions={this.props.permissions}
                            isOnline={this.props.isOnline} />
                        </SettingsSection>
                      }
                    </Accordion>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid >
      </Scrollable>
    );
  }

  private async setMenuItem(event: React.MouseEvent<HTMLDivElement>, data: AccordionTitleProps) {
    let menuItem = this.state.activeMenuItem === data.index ? -1 : data.index;
    await this.setState(update(this.state, {
      activeMenuItem: { $set: menuItem }
    }));
    await this.props.clearErrorMessage();
  }

  private updateTenantPreferences() {
    this.props.updateTenantPreferences(this.state.tenant.id, this.state.tenant.language);
  }

  private setTenant(tenant: Tenant): void {
    this.setState({
      tenant
    });
  }

  private hasAccessToPreferencesSection() {
    return hasPermissionToAccessPage(Permission.TenantPreferences, this.props.permissions);
  }

  private hasAccessToCredentialsSection() {
    return hasPermissionToAccessPage(Permission.TenantProviderCredentials, this.props.permissions);
  }

  private getActiveMenuItem(): SettingsMenuItem {
    let activeMenuItem: SettingsMenuItem = this.state.activeMenuItem;

    if (activeMenuItem === SettingsMenuItem.Unknown) {
      if (this.hasAccessToPreferencesSection()) {
        activeMenuItem = SettingsMenuItem.Preferences;
      } else if (this.hasAccessToCredentialsSection()) {
        activeMenuItem = SettingsMenuItem.NmvsProviderCredentials;
      }
    }

    return activeMenuItem;
  }
}


// WEBPACK FOOTER //
// ./src/pages/settings/component.tsx